import { Select } from 'antd'
import axios from 'axios'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { masterInstance } from 'utils/axios'

function HRSelect(props) {
  const { dependentValue,  optionsUrl, setFieldValue, _field, name, isDefault, getFieldValue } = props
  const [ options, setOptions ] = useState([])
  const [ loading, setLoading ] = useState(false)
  const [ init, setInit ] = useState(true)
  useEffect(() => {
    if(props.dependentValue){
      getOptions()
      if(typeof isDefault === 'boolean'){
      }else{
        if(!init) {
          setFieldValue(name, '')
        }
        else {
          setInit(false)
        }
      }
    }

  },[props.dependentValue])

  const getOptions = () => {
    setLoading(true)
    if(optionsUrl) {
      if(typeof optionsUrl === 'string') {
        masterInstance({
          method: 'get',
          url: `${optionsUrl}/${dependentValue}`,
        }).then(res => {
          let tmp = []
          res.data.map((item, i) => {
            tmp.push({
              ...item,
              value: item.id,
              label: item.name,
              // value: item[props.optionValue] ? item[props.optionValue] : item.id,
              // label: item[props.optionLabel] ? item[props.optionLabel] : item.name,
            })
          })
          setOptions(tmp)  
        }).catch(err => {
        }).then(() => {
          setLoading(false)
        })
      }
      else{
        setOptions(optionsUrl)
      }
    }
  }

  const handleOnChange = async (value, option) => {
    await setFieldValue(`${_field.name}`, value)
  }

  return (
    <Select loading={loading} options={options} allowClear {...props} />
  )
}

export default HRSelect